import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from 'src/app/shared/global';
//import { EventEmitter } from 'stream';

@Component({
  selector: 'app-button-selection',
  templateUrl: './button-selection.component.html',
  styleUrls: ['./button-selection.component.scss']
})
export class ButtonSelectionComponent implements OnInit {
  @Output() buttonSelectEvent = new EventEmitter<any>();
  buttonLabels: any = [];//string[] = [];
  constructor(private router:Router, private global: Global) { 
    this.buttonSelectEvent = new EventEmitter();
  }

  ngOnInit(): void {
    this.assignLabelToButton();
  }

  redirectLessonPage(destination, catIndex) {
    console.log('here i am - index', catIndex);
    this.global.selectedEduCategory = catIndex;
    this.global.selectedEduCategoryTitle = destination;
    this.buttonSelectEvent.emit(destination);
    //if (destination == 'medicare') {
      this.router.navigate(['/medicare'], { queryParams: { org: this.global.orgID } });
    //}
  }

  assignLabelToButton() {
    this.global.getEduLessonObj.forEach(element => {
      // element = JSON.parse(element);
      console.log('element', element.title);
      this.buttonLabels.push({ 'title' : element.title, 'index': element.orderId - 1 });    
    });
    console.log('this.buttonLabels', this.buttonLabels)
  }
}
